// The book's own settings — what every scene inherits.
//
// The same four controls the Lua settings panel holds
// (side_panels/settings_panel.lua): the colour behind the pictures, the kind
// of content this is, whether it is divided into chapters, and the font the
// words fall back to.
import React from "react"
import Modal from "aldoo-ra/Modal"
import Button from "aldoo-ra/Button"
import useProductEditorTexts from "aldoo-ra/CMSModels/StoreProduct/useProductEditorTexts"
import { Field, TextInput } from "../../../AdminShared/ui"
import { Switch } from "../shared/shared"
import { BOOK_COLORS } from "./editorModel"

export default function SettingsDialog({ editor, onClose }) {
  const t = useProductEditorTexts()
  const { read, set } = editor
  const colour = read("bookSettings.backgroundColor") || "white"

  return (
    <Modal
      isOpen
      onClose={onClose}
      variant="admin_compact"
      title={t`Book settings`}
      styleOverrides={{ container: "bg-admin_paper border-admin_bordered w-full max-w-[520px] rounded-md border shadow-lg" }}
    >
      <div className="flex flex-col gap-4 p-4" data-testid="book-settings">
        <Field label={t`Background colour`} hint={t`What shows behind a picture that does not fill the screen`}>
          <div className="flex items-center gap-2">
            {BOOK_COLORS.map((name) => (
              <button
                key={name}
                type="button"
                onClick={() => set("bookSettings.backgroundColor", name)}
                title={name}
                className={`w-8 h-8 rounded border ${colour === name ? "border-admin_primary ring-1 ring-admin_primary" : "border-admin_bordered"}`}
                style={{ background: name }}
              />
            ))}
            <TextInput value={colour} onChange={(value) => set("bookSettings.backgroundColor", value)} className="flex-1" placeholder="#000000" />
          </div>
        </Field>

        <Field label={t`Default font`} hint={t`Used by any scene that names no font of its own`}>
          <TextInput value={read("defaultFont") || ""} onChange={(value) => set("defaultFont", value)} placeholder={t`e.g. Nunito`} />
        </Field>

        <Switch checked={!!read("bookSettings.useChapters")} onChange={(value) => set("bookSettings.useChapters", value)} label={t`Divided into chapters`} />

        <div className="flex justify-end">
          <Button variant="admin_secondary" onClick={onClose}>
            {t`Done`}
          </Button>
        </div>
      </div>
    </Modal>
  )
}
